<template>
  <v-container fluid>
    <v-data-iterator
      :items="items"
      :items-per-page.sync="itemsPerPage"
      :page="page"
      :search="search"
      :sort-by="sortBy.toLowerCase()"
      :sort-desc="sortDesc"
      hide-default-footer
      disable-pagination
    >
      <template v-slot:header>
        <v-toolbar dark color="blue darken-3" class="mb-1">
          <v-text-field
            v-model="search"
            clearable
            solo-inverted
            hide-details
            prepend-inner-icon="mdi-magnify"
            label="Search"
            dense
          ></v-text-field>
        </v-toolbar>
      </template>

      <template v-slot:default="props">
        <!-- <template> -->
        <v-row align="center" justify="center" dense>
          <!-- <v-col
              v-for="item in props.items"
              :key="item.RID"
              cols="12"
              sm="6"
              md="4"
              lg="3"
          >-->

          <v-col v-for="(item, i) in props.items" :key="i" cols="12" md="6">
            <v-card :color="item.Color" dark>
              <div class="d-flex flex-no-wrap">
                <div>
                  <!-- <v-card-title
                    class="headline"
                    v-text="item.Name"
                  ></v-card-title>-->
                  <v-card-title class="subheading font-weight-bold">
                    {{ item.Event }} / {{ item.EventDescription }}
                    <div v-if="item.IsOpen">
                      <v-chip class="mx-2" color="green" dark fab small>
                        <v-icon small>fa-lock-open</v-icon>
                      </v-chip>
                    </div>
                    <div v-if="!item.IsOpen">
                      <v-chip class="mx-2" color="red" dark fab small>
                        <v-icon small>fa-lock</v-icon>
                      </v-chip>
                    </div>
                    <!-- <v-btn text color="primary" @click="reveal = true">
                      More info
                    </v-btn> -->
                    <v-menu
                      bottom
                      origin="center center"
                      transition="scale-transition"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="mx-2"
                          fab
                          dark
                          small
                          :color="item.Color"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon>mdi-chevron-down</v-icon>
                        </v-btn>
                      </template>
                      <v-list
                        nav
                        dense
                        @click="menuSelected(selectedMenuItem, item)"
                      >
                        <v-list-item-group
                          v-model="selectedMenuItem"
                          color="primary"
                        >
                          <v-list-item>
                            <v-list-item-icon>
                              <v-icon>mdi-information</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title>More info</v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-divider></v-divider>
                          <v-list-item>
                            <v-list-item-icon>
                              <v-icon>mdi-link</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title
                                >Join WhatsApp Group</v-list-item-title
                              >
                            </v-list-item-content>
                          </v-list-item>
                          <v-divider></v-divider>
                          <v-list-item>
                            <v-list-item-icon>
                              <v-icon>mdi-link</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title
                                >Join PureTrack Group</v-list-item-title
                              >
                            </v-list-item-content>
                          </v-list-item>
                          <v-divider></v-divider>
                          <v-list-item>
                            <v-list-item-icon>
                              <v-icon>mdi-account-multiple</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title>Box Openers</v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list-item-group>
                      </v-list>
                    </v-menu>
                  </v-card-title>
                  <v-card-text class="text-h8">{{ item.Comment }}</v-card-text>
                  <v-card-actions>
                    <v-badge
                      color="blue"
                      overlap
                      :content="item.Ant"
                      v-if="item.Ant > 0"
                    >
                      <v-btn
                        rounded
                        small
                        color="primary"
                        :to="item.ToLsbLink"
                        v-if="item.Ant > 0"
                      >
                        Pilots
                      </v-btn>
                    </v-badge>
                    <v-spacer></v-spacer>
                    <v-badge
                      color="blue"
                      overlap
                      :content="item.AntPos"
                      v-if="item.AntPos > 0"
                    >
                      <v-btn
                        rounded
                        small
                        color="primary"
                        :to="item.ToMapBoxLink"
                        v-if="item.AntPos > 0"
                        class=""
                        >Map
                      </v-btn></v-badge
                    >
                    <v-spacer></v-spacer>
                    <v-menu offset-y v-if="item.Ant > 0">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          color="primary"
                          dark
                          v-bind="attrs"
                          v-on="on"
                          small
                        >
                          <v-icon>mdi-chevron-down</v-icon>
                          Live tracking
                        </v-btn>
                      </template>
                      <v-list :color="item.Color">
                        <v-list-item
                          ><v-btn
                            rounded
                            x-small
                            color="primary"
                            :href="item.SafeSkyLink"
                            target="_blank"
                            v-if="item.Ant > 0"
                            >SafeSky</v-btn
                          >
                        </v-list-item>
                        <v-list-item
                          ><v-btn
                            rounded
                            x-small
                            color="primary"
                            :href="item.PureTrackLink"
                            target="_blank"
                            v-if="item.Ant > 0"
                            >PureTrack</v-btn
                          ></v-list-item
                        >
                        <v-list-item
                          ><v-btn
                            rounded
                            x-small
                            color="primary"
                            :href="item.XContestLiveLink"
                            target="_blank"
                            v-if="item.Ant > 0"
                            >XContest</v-btn
                          ></v-list-item
                        >
                        <v-list-item
                          ><v-btn
                            rounded
                            x-small
                            color="primary"
                            :href="item.FlymasterLiveLink"
                            target="_blank"
                            v-if="item.Ant > 0"
                            >Flymaster</v-btn
                          ></v-list-item
                        >
                      </v-list>
                    </v-menu>
                    <!-- <v-spacer></v-spacer> -->
                  </v-card-actions>
                  <v-expand-transition>
                    <v-alert
                      :color="item.Color"
                      dense
                      v-if="reveal && selectedBox.EventId == item.EventId"
                    >
                      <v-card-subtitle>{{
                        item.Action +
                        " on " +
                        item.Dato +
                        " " +
                        item.Tid +
                        " By " +
                        item.OpenedBy +
                        ", Mobile: " +
                        item.OpenedByMID
                      }}</v-card-subtitle>

                      <v-spacer></v-spacer>
                      <v-btn @click="reveal = false" text color="primary"
                        >Close info<v-icon small right>mdi-close</v-icon></v-btn
                      >
                    </v-alert>
                  </v-expand-transition>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </template>

      <template v-slot:footer>
        <v-row class="mt-2" align="center" justify="center">
          <span class="grey--text">Items</span>
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn dark text color="primary" class="ml-2" v-on="on">
                {{ itemsPerPage }}
                <v-icon>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(number, index) in itemsPerPageArray"
                :key="index"
                @click="updateItemsPerPage(number)"
              >
                <v-list-item-title>{{ number }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-spacer></v-spacer>

          <span class="mr-4 grey--text"
            >Page {{ page }} of {{ numberOfPages }}</span
          >
          <v-btn
            fab
            dark
            color="blue darken-3"
            class="mr-1"
            @click="formerPage"
          >
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn fab dark color="blue darken-3" class="ml-1" @click="nextPage">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-row>
      </template>
    </v-data-iterator>
    <!-- ///////////// DIALOG //////////////// -->
    <v-dialog
      transition="dialog-bottom-transition"
      max-width="600"
      :value="whatsAppDialog"
    >
      <v-card>
        <v-toolbar color="primary" dark dense>
          WhatsApp Group
          <v-spacer></v-spacer>
          Box:
          <v-spacer></v-spacer>
          <v-chip color="blue"
            >{{ selectedBox.Event }} /
            {{ selectedBox.EventDescription }}</v-chip
          >
        </v-toolbar>
        <div v-if="loggedIn">
          <v-card-text>
            <div class="text-h6 pa-2">
              The WhatsApp group should only be used to communicate relevant
              info for <u>all members of the group</u>.
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-text>
            <div class="text-h8 pa-2">
              Like:
              <ul>
                <li>
                  Box opening/closing. (Done by the box opener from PGBox).
                </li>
                <li>Planned Box openings.</li>
                <li>Essential info, relevant for the box.</li>
              </ul>
              <v-divider></v-divider>
              Not for:
              <ul>
                <li>"Small talk."</li>
                <li>"Chatting".</li>
                <li>Personal messages.</li>
                <!-- <li>Request to open.</li> -->
              </ul>
              <v-divider></v-divider>
              <v-checkbox
                v-model="agree"
                label="I agree!"
                color="red"
                value="red"
                hide-details
              ></v-checkbox>
            </div>
          </v-card-text>
        </div>

        <v-card-text v-if="!loggedIn">
          <div class="text-h6 pa-12">
            You need to log in before you can se this!
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-center">
          <v-btn
            rounded
            color="primary"
            v-if="agree"
            outlined
            :href="selectedBox.WhatsAppLink"
            target="_blank"
            :disabled="!selectedBox.WhatsAppLinkEnabled || !loggedIn"
          >
            <div v-if="selectedBox.WhatsAppLinkEnabled">Join the group</div>
            <div v-else>WhatsApp Group is not available!</div></v-btn
          >
          <v-btn text outlined @click="whatsAppDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
      <!-- </template> -->
    </v-dialog>
    <!-- ///////////// DIALOG WHATSAPP GROUP END //////////////// -->
    <!-- ///////////// DIALOG PURETRACK GROUP //////////////// -->
    <v-dialog
      transition="dialog-bottom-transition"
      max-width="600"
      :value="pureTrackDialog"
    >
      <v-card>
        <v-toolbar color="primary" dark dense>
          PureTrack Group
          <v-spacer></v-spacer>
          Box:
          <v-spacer></v-spacer>
          <v-chip color="blue"
            >{{ selectedBox.Event }} /
            {{ selectedBox.EventDescription }}</v-chip
          >
        </v-toolbar>
        <div v-if="loggedIn">
          <v-card-text>
            <div class="text-h6 pa-2">
              The PureTrack group are made to be used
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-text>
            <div class="text-h8 pa-2">
              By para- and hangglider pilots:
              <ul>
                <li>Registered in PGBox.</li>
                <li>For flying in Danger Areas (boxes).</li>
                <li>Or in a competition setting.</li>
                <li>
                  <i
                    >Please, do not share the PureTrack Group invitation link to
                    non PGBox users.</i
                  >
                </li>
              </ul>
              <v-divider></v-divider>
              <v-checkbox
                v-model="agreePureTrack"
                label="I agree!"
                color="red"
                value="red"
                hide-details
              ></v-checkbox>
            </div>
          </v-card-text>
        </div>

        <v-card-text v-if="!loggedIn">
          <div class="text-h6 pa-12">
            You need to log in before you can se this!
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-center">
          <v-btn
            rounded
            color="primary"
            v-if="agreePureTrack"
            outlined
            :href="selectedBox.PureTrackGroupLink"
            target="_blank"
            :disabled="!selectedBox.WhatsAppLinkEnabled || !loggedIn"
          >
            <div v-if="selectedBox.PureTrackGroupLinkEnabled">
              Join the group
            </div>
            <div v-else>PureTrack Group is not available!</div></v-btn
          >
          <v-btn text outlined @click="pureTrackDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
      <!-- </template> -->
    </v-dialog>
    <!-- ///////////// DIALOG PURETRACK GROUP END //////////////// -->
    <v-dialog
      transition="dialog-bottom-transition"
      max-width="600"
      :value="boxOpenerDialog"
    >
      <v-card>
        <v-toolbar color="primary" dark dense>
          Box Openers
          <v-spacer></v-spacer>
          Box:
          <v-spacer></v-spacer>
          <v-chip color="blue"
            >{{ selectedBox.Event }} /
            {{ selectedBox.EventDescription }}</v-chip
          >
        </v-toolbar>

        <!-- <v-card-text>
          <div class="text-h6 pa-2">Not implemented yet!</div>
        </v-card-text> -->
        <v-divider></v-divider>
        <!-- <v-card-text>
          <div class="text-h8 pa-2"></div>
        </v-card-text> -->

        <v-card-actions class="justify-center">
          <v-btn rounded color="primary" @click="getEventRoles"
            >Get List of Box Openers
          </v-btn>
          <v-btn text outlined @click="boxOpenerDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>

      <v-data-table
        :headers="roleHeaders"
        :items="roles"
        :item-class="row_classes"
        :single-expand="expand"
        :expanded.sync="expanded"
        item-key="Name"
        show-expand
        class="elevation-1 pa-2 striped-table"
        style="
          .theme--light.v-data-table tbody tr:nth-of-type(even) {
            background-color: rgba(0, 0, 0, 0.03);
          }
        "
      >
        <!-- <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>Box Openers </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
        </template> -->
        <!-- <template v-slot:default="{ items }">
          <v-row>
            <v-col v-for="item in items" :key="item.Name" cols="12">
              {{ item.Name }}
            </v-col>
          </v-row>
        </template> -->
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <v-chip>{{ item.MID }}</v-chip>
            -
            <!-- <div class="row pa-1"> -->
            <v-btn small color="primary" :href="item.TelLink"
              ><v-icon small>fa-phone</v-icon></v-btn
            >
            <!-- </div> -->
            -
            <v-btn small color="primary" :href="item.SmsLink"
              ><v-icon small>fa-sms</v-icon></v-btn
            >
          </td>
        </template>
      </v-data-table>

      <!-- </template> -->
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "axios";
export default {
  name: "EventCard",
  props: {
    items: {
      type: Array,
    },
    loading: Boolean,
    loggedIn: Boolean,
  },
  data() {
    return {
      itemsPerPageArray: [10, 20, 40, 100, 200],
      search: "",
      filter: {},
      sortDesc: false,
      page: 1,
      itemsPerPage: 100,
      sortBy: "event",
      keys: ["Event", "EventDescription", "Status"],
      e1: 1,
      reveal: false,
      selectedMenuItem: undefined,
      // alert: false,
      whatsAppDialog: false,
      pureTrackDialog: false,
      boxOpenerDialog: false,
      selectedBox: [],
      agree: false,
      agreePureTrack: false,
      roles: [],
      expanded: [],
      expand: true,
      roleHeaders: [
        { text: "Name", value: "Name" },
        { text: "Role", value: "RoleName" },
      ],
      baseUrl: "https://pgapi.azurewebsites.net/dbapi/",
      // baseUrl: "http://localhost:3000/dbapi/",
      //   loading: true,
      menuSelected(item, box) {
        this.selectedBox = box;
        if (item == 0) {
          this.reveal = true;
        }
        if (item == 1) {
          this.whatsAppDialog = true;
        }
        if (item == 2) {
          this.pureTrackDialog = true;
        }
        if (item == 3) {
          this.boxOpenerDialog = true;
          this.roles = [];
        }
        this.selectedMenuItem = undefined;
      },
    };
  },
  computed: {
    numberOfPages() {
      return Math.ceil(this.items.length / this.itemsPerPage);
    },
    filteredKeys() {
      return this.keys.filter((key) => key !== `Name`);
    },
  },
  methods: {
    nextPage() {
      if (this.page + 1 <= this.numberOfPages) this.page += 1;
    },
    formerPage() {
      if (this.page - 1 >= 1) this.page -= 1;
    },
    updateItemsPerPage(number) {
      this.itemsPerPage = number;
    },
    getEventRoles() {
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
        },
      };

      var EventId = this.selectedBox.EventId; // this.regId;
      var uri = this.baseUrl + "geteventroles/" + EventId;
      axios
        .get(uri, axiosConfig)
        .then((response) => {
          this.roles = response.data;
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    row_classes(item) {
      if (item.IsOddRow == 0) {
        return "odd-row"; //can also return multiple classes e.g ["orange","disabled"]
      }
      return "even-row";
    },
  },
};
</script>

<style>
.odd-row {
  background-color: #ebf1f0;
}
.even-row {
  background-color: #b0d0cb;
}
</style>